export default (namespace) => ({
  [`${namespace}.hireOnline`]: 'Contrata online',
  [`${namespace}.submit`]: 'Contratar',
  [`${namespace}.callUsFree`]: 'Llámanos gratis (900 533 691)',
});
